/* VetPro "Find your dog's formula" quiz logic. Ported from v5 quiz.html.
   Live product data (name/url/img/price/plans) is injected via window.VPQ_PRODUCTS from Liquid;
   editorial META (dose kind, pack count, timelines) lives here. v5. */
(function () {
  'use strict';

  var META = {
    hip:    { kind: 'chew', count: 120, timeline: [['Weeks 1–2','Loading phase — double dose, included free. Levels building quietly.'],['Weeks 3–4','Early signs: easier rising, more willingness on stairs.'],['Weeks 6+','The difference most owners notice. Keep the daily rhythm.']] },
    multi:  { kind: 'chew', count: 120, timeline: [['Weeks 1–2','Most dogs take to the chew immediately — nutrients start filling the gaps.'],['Weeks 3–4','Coat shine and steadier digestion are usually the first visible signs.'],['Ongoing','A multivitamin pays off in years, not weeks. Consistency wins.']] },
    allergy:{ kind: 'chew', count: 120, timeline: [['Weeks 1–2','Actives building. Add post-walk paw wipe-downs to remove pollen.'],['Weeks 3–6','Less licking, calmer skin, quieter nights — where most owners see it.'],['Each season','Start a month before your dog’s bad season for the smoothest ride.']] },
    gut:    { kind: 'scoop', timeline: [['Days 3–7','The gut population starts shifting — a briefly gassier dog is normal.'],['Weeks 2–4','Steadier stools, fewer sensitive-stomach episodes.'],['Ongoing','Daily support carries the gut through diet changes and stress.']] },
    calm:   { kind: 'chew', count: 120, timeline: [['First use','Give 30–90 minutes before the stressor, paired with a calm space.'],['Daily use','Through storm season or a move, a steadier baseline builds in 1–2 weeks.'],['Remember','Calm without sedation — your dog stays your dog.']] },
    salmon: { kind: 'pump', timeline: [['Weeks 1–2','Ramp up slowly onto meals — rich oil, enthusiastic guts.'],['Weeks 4–8','The glossy-coat payoff arrives; quieter benefits underway.'],['Ongoing','Joints, heart, and brain support compound over months.']] },
    dental: { kind: 'stick' }
  };

  var PRIORITY = ['joint','skin','gut','calm','prevention','breath','coat','wellness'];
  var CONCERN_TO_PRODUCT = { joint:'hip', prevention:'hip', skin:'allergy', gut:'gut', calm:'calm', wellness:'multi', coat:'salmon', breath:'dental' };
  var MULTI_WHY = { gut:'Daily pre + probiotics for the tummy troubles you flagged.', coat:'Omega-3s for the coat shine you flagged.', calm:'Non-sedating support for the anxious moments you flagged.', breath:'A daily stick for the breath & dental box you ticked.', skin:'Three-angle skin support for the itching you flagged.', joint:'Clinical-strength joint support for the stiffness you flagged.', prevention:'Early joint support for the wear you want to stay ahead of.', wellness:'One daily chew covering the foundations.' };
  var CHEWS = [1,2,3,4], WLABEL = ['under-20 lb','21–50 lb','51–75 lb','76 lb+'];
  var LABELS = ['Getting started','Question 1 of 4 · Weight','Question 2 of 4 · Age','Question 3 of 4 · What is going on','Almost there · Which one first','Question 4 of 4 · Your plan, delivered','Done'];
  var WIDTHS = [8,24,40,56,70,84,100];
  var TITLES = { joint:'Stiffness or slowing down', prevention:'Staying ahead of joint wear', skin:'Itching & scratching', gut:'Tummy troubles', calm:'Anxious moments', breath:'Breath & dental', coat:'Dull coat & shedding', wellness:'Just overall daily health' };

  var LIVE = window.VPQ_PRODUCTS || {};

  /* Delivery cadences, kept deliberately in step with ALLOWED_MONTHS in vp-buybox.liquid —
     the quiz and the PDP must not offer different plans for the same product. Every plan is
     the same 35% off now, so the ceiling is supply rather than price: the longest a pack
     lasts is 120 days, which is why Recurpay's 5- and 6-month plans are left out of both. */
  var ALLOWED_MONTHS = [1, 2, 3, 4];
  function planMonths(name) { var m = /(\d+)\s*month/i.exec(name || ''); return m ? parseInt(m[1], 10) : null; }
  Object.keys(LIVE).forEach(function (k) {
    LIVE[k].plans = (LIVE[k].plans || [])
      .map(function (pl) { pl.months = planMonths(pl.name); return pl; })
      .filter(function (pl) { return pl.months && ALLOWED_MONTHS.indexOf(pl.months) !== -1; })
      .sort(function (a, b) { return a.months - b.months; });
  });
  // The cadence for a product at the bundle's current setting, falling back to the shortest
  // one it carries — products don't all have to offer the same set.
  function planFor(p) {
    if (!p.plans || !p.plans.length) return null;
    return p.plans.find(function (pl) { return pl.months === S.planMonths; }) || p.plans[0];
  }
  function prod(key) { return Object.assign({}, META[key] || {}, LIVE[key] || {}); }

  // planMonths: delivery cadence for the whole bundle. Set from the primary formula's
  // days-of-supply when the plan is built; planTouched freezes it once the customer picks.
  var S = { name:'', weight:1, age:'adult', concern:'joint', primaryPick:null, hadTiebreak:false, multi:{}, subOn:true, planMonths:null, planTouched:false };
  var BUNDLE = [];
  var steps, root;

  function $(id) { return document.getElementById(id); }
  function money(n) { return '$' + Number(n).toFixed(2); }
  // Best-effort E.164 (US-centric) for SMS consent; null if implausible.
  function normPhone(raw) {
    if (!raw) return null;
    var s = String(raw).trim(), plus = s.charAt(0) === '+', d = s.replace(/[^0-9]/g, '');
    if (plus) return (d.length >= 8 && d.length <= 15) ? '+' + d : null;
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    return (d.length >= 8 && d.length <= 15) ? '+' + d : null;
  }

  function goto(n) {
    if (n === 1) { S.name = $('vpq-name').value.trim(); personalize(); }
    for (var i = 0; i < steps.length; i++) steps[i].classList.toggle('is-active', +steps[i].dataset.step === n);
    $('vpq-bar').style.width = (WIDTHS[n] || 90) + '%';
    $('vpq-count').textContent = LABELS[n];
    window.scrollTo({ top: 0, behavior: 'instant' });
  }
  function personalize() {
    var n = S.name || 'your dog';
    root.querySelectorAll('.dog').forEach(function (el) { el.textContent = n; });
  }

  function afterIssues() {
    var picked = PRIORITY.filter(function (k) { return S.multi[k]; });
    S.primaryPick = null;
    if (picked.length >= 2) {
      S.hadTiebreak = true;
      $('vpq-tiebreak').innerHTML = picked.map(function (k) {
        return '<button type="button" class="vpq-opt" data-pick="' + k + '"><span class="t">' + TITLES[k] + '</span></button>';
      }).join('');
      $('vpq-tiebreak').querySelectorAll('[data-pick]').forEach(function (b) {
        b.addEventListener('click', function () { S.primaryPick = b.dataset.pick; setTimeout(function () { goto(5); }, 180); });
      });
      goto(4);
    } else { S.hadTiebreak = false; goto(5); }
  }

  function doseLine(p) {
    var n = S.name || 'your dog';
    if (p.kind === 'chew') {
      var c = CHEWS[S.weight], days = Math.round(p.count / c);
      return { text: 'For ' + n + ' (' + WLABEL[S.weight] + '): ' + c + ' chew' + (c > 1 ? 's' : '') + ' daily · ' + p.count + ' ct = ' + days + '-day supply', days: days };
    }
    if (p.kind === 'scoop') return { text: 'For ' + n + ': 1 scoop daily on food · 60-day supply', days: 60 };
    if (p.kind === 'pump') return { text: 'For ' + n + ': ' + CHEWS[S.weight] + ' pump' + (S.weight ? 's' : '') + ' daily on meals', days: 60 };
    return { text: 'For ' + n + ': 1 daily', days: 30 };
  }

  function finish(skipEmail) {
    if (!skipEmail) {
      var e = $('vpq-email').value.trim();
      if (!e || e.indexOf('@') < 0) { $('vpq-email').focus(); return; }
      S.email = e;
      var ph = $('vpq-phone'), sc = $('vpq-sms');
      S.phone = ph ? ph.value.trim() : '';
      S.smsConsent = sc ? sc.checked : false;
    }
    var picked = PRIORITY.filter(function (k) { return S.multi[k]; });
    if (S.primaryPick) picked = [S.primaryPick].concat(picked.filter(function (k) { return k !== S.primaryPick; }));
    S.concern = picked[0] || 'wellness';
    var key = CONCERN_TO_PRODUCT[S.concern];
    var p = prod(key);
    var n = S.name || 'your dog';
    var d = doseLine(p);

    // Sync quiz answers to Klaviyo — same Client API pattern as the /start flow (keys injected via window.VPQ_KLAVIYO)
    if (S.email) {
      try {
        var K = window.VPQ_KLAVIYO || {};
        if (K.key) {
          // snake_case per the email strategy's standard property names (§2.5) — the same
          // fields the pet-profile sync writes, so flow copy like {{ person.dog_name }}
          // resolves whether the value came from the quiz or from a saved pet.
          // PascalCase duplicates are still sent so existing flows/segments built on the
          // old names keep working; drop them once those have been repointed.
          var kprops = {
            dog_name: S.name || '',
            dog_weight_band: WLABEL[S.weight] || '',
            dog_age_band: S.age || '',
            concerns: picked,
            recommended_product: p.name || '',
            recommended_product_url: p.link || '',
            source: 'formula_quiz',

            DogName: S.name || '',
            DogWeightBand: WLABEL[S.weight] || '',
            DogAgeBand: S.age || '',
            Concerns: picked,
            RecommendedProduct: p.name || '',
            RecommendedProductUrl: p.link || ''
          };
          fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(K.key), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
            body: JSON.stringify({ data: { type: 'event', attributes: {
              time: new Date().toISOString(),
              properties: kprops,
              metric: { data: { type: 'metric', attributes: { name: 'Completed Dog Quiz' } } },
              profile: { data: { type: 'profile', attributes: { email: S.email, properties: kprops } } }
            } } })
          }).catch(function () {});
          if (K.list) {
            var subAttrs = { email: S.email };
            var subs = { email: { marketing: { consent: 'SUBSCRIBED' } } };
            if (S.smsConsent && S.phone) {
              var ph164 = normPhone(S.phone);
              if (ph164) { subAttrs.phone_number = ph164; subs.sms = { marketing: { consent: 'SUBSCRIBED' } }; }
            }
            subAttrs.subscriptions = subs;
            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(K.key), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
              body: JSON.stringify({ data: { type: 'subscription', attributes: {
                custom_source: 'Formula quiz',
                profile: { data: { type: 'profile', attributes: subAttrs } }
              }, relationships: { list: { data: { type: 'list', id: K.list } } } } })
            }).catch(function () {});
          }
        }
      } catch (e) {}
    }

    $('vpq-r-title').textContent = (S.name ? S.name + "'s" : "Your dog's") + ' plan';
    var whys = {
      joint: "Based on " + n + "'s weight and the stiffness you're seeing, we'd start with clinical-strength joint support — dosed exactly for " + WLABEL[S.weight] + " dogs.",
      prevention: (S.age === 'puppy' ? 'For a growing dog, check timing with your vet first — then' : 'For an active dog thinking long-term,') + ' clinical-strength joint support is the right early move, dosed for ' + WLABEL[S.weight] + ' dogs.',
      skin: 'For the itching and licking you described, skin support from three angles — colostrum, omega-3s, and probiotics — dosed to ' + n + "'s weight.",
      gut: 'For a gut that needs steadying, pre- and probiotics together — the bacteria and the fuel they need.',
      calm: 'For ' + n + "'s anxious moments: relaxation support without sedation, timed before the stressors you know are coming.",
      wellness: 'For head-to-tail daily coverage: one chew covering coat, gut, joints, immunity, and heart — dosed to ' + n + "'s weight.",
      coat: "For the shine you're after: EPA/DHA omega-3s pumped straight onto meals — the visible payoff arrives in 4–8 weeks.",
      breath: 'For the breath situation: a daily stick that scrubs while ' + n + " chews, with prebiotics for the mouth's balance."
    };
    $('vpq-r-why').textContent = whys[S.concern] || '';
    $('vpq-r-img').src = p.img || ''; $('vpq-r-img').alt = p.name || '';
    $('vpq-r-name').textContent = p.name || '';
    $('vpq-r-dose').textContent = d.text;

    var tl = $('vpq-r-timeline');
    if (p.timeline) {
      tl.hidden = false;
      tl.innerHTML = '<p class="vpq-tl-h">The honest timeline</p>' + p.timeline.map(function (row) {
        return '<div class="vpq-tl-row"><p class="k">' + row[0].toUpperCase() + '</p><p class="b">' + row[1] + '</p></div>';
      }).join('');
    } else { tl.hidden = true; }

    // Build the bundle: primary (always in) + recommended add-ons. Flagged concerns are pre-selected;
    // the generic daily-foundation suggestions (multi/salmon) are offered but unchecked.
    var seen = {}; seen[key] = true;
    BUNDLE = [{ p: p, why: '', primary: true, selected: true }];
    picked.slice(1).forEach(function (k) {
      var cand = CONCERN_TO_PRODUCT[k];
      if (cand && !seen[cand]) { seen[cand] = true; BUNDLE.push({ p: prod(cand), why: MULTI_WHY[k], selected: true }); }
    });
    if (key !== 'multi' && !seen.multi) { seen.multi = true; BUNDLE.push({ p: prod('multi'), why: 'The daily foundation under any plan — coat, gut, joints, immunity, and heart in one chew.', selected: false }); }
    if (key !== 'salmon' && !seen.salmon) { seen.salmon = true; BUNDLE.push({ p: prod('salmon'), why: 'Omega-3s for skin, coat, joints, and heart — pumped straight onto meals.', selected: false }); }
    // Default the cadence to whatever matches the primary formula's supply, the same rule
    // the PDP uses. It follows the dog's weight (a 120 ct pack is 60 days at 2 chews a day
    // but only 30 at 4) until the customer picks a cadence themselves.
    if (!S.planTouched) S.planMonths = recMonths(BUNDLE[0]);
    renderBundle();

    var notes = [];
    if (S.age === 'puppy') notes.push(n + ' is under a year old — run this plan past your veterinarian before starting; growing joints have their own rules.');
    if (S.email) notes.push('Plan sent to ' + S.email + '. We’ll check in as ' + n + ' hits each milestone.');
    $('vpq-r-note').textContent = notes.join(' ');

    goto(6);
    $('vpq-bar').style.width = '100%';
    $('vpq-count').textContent = 'Plan complete';
  }

  function itemPrice(b) {
    var pl = S.subOn ? planFor(b.p) : null;
    return pl ? pl.price : b.p.one;
  }

  /* The cadence closest to how long the primary formula actually lasts. Only the primary is
     consulted: it is the product the plan is built around and the only one guaranteed to be
     in the bundle, and a single cadence has to come from somewhere. Add-ons on a different
     supply are called out in the note rather than silently split onto their own plan. */
  function recMonths(b) {
    if (!b || !b.p.plans || !b.p.plans.length) return null;
    var days = doseLine(b.p).days, best = b.p.plans[0], bestDiff = Infinity;
    b.p.plans.forEach(function (pl) {
      var diff = Math.abs(pl.months * 30 - days);
      if (diff < bestDiff) { bestDiff = diff; best = pl; }
    });
    return best.months;
  }

  function cadenceLabel(months) { return months === 1 ? 'Every month' : 'Every ' + months + ' months'; }
  var REC_BADGE = '<span class="vpq-freq__rec">Recommended</span>';

  function freqOpen(open) {
    var menu = $('vpq-freq-menu'), trigger = $('vpq-freq-trigger');
    if (!menu || !trigger) return;
    menu.hidden = !open;
    trigger.setAttribute('aria-expanded', String(open));
    if (!open) return;
    var sel = menu.querySelector('[aria-selected="true"]') || menu.firstElementChild;
    if (sel) sel.focus();
  }
  function chooseMonths(li) {
    S.planMonths = parseInt(li.dataset.months, 10);
    S.planTouched = true;
    freqOpen(false);
    renderBundle();
    // Back to the trigger: renderBundle rebuilds the menu, so the item that had focus is gone.
    var t = $('vpq-freq-trigger'); if (t) t.focus();
  }

  function renderFreq() {
    var wrap = $('vpq-freq');
    if (!wrap) return;
    var primary = BUNDLE[0];
    var plans = (primary && primary.p.plans) || [];
    // Hidden when subscription is off, and when there is only one cadence to pick — a lone
    // pill reads as a control that doesn't work.
    var show = S.subOn && plans.length > 1;
    wrap.hidden = !show;
    // An open menu inside a row that just got hidden would reappear on the next repaint.
    if (!show) { freqOpen(false); return; }

    var current = planFor(primary.p), rec = recMonths(primary);
    // Price shown per pill is the whole bundle at that cadence, not one product's — in a
    // bundle a single product's price begs the question "which one?", and the total is the
    // number the customer is actually comparing.
    function bundleAt(months) {
      var t = 0;
      BUNDLE.forEach(function (b) {
        if (!b.selected) return;
        var match = (b.p.plans || []).find(function (x) { return x.months === months; });
        t += match ? match.price : b.p.one;
      });
      return t;
    }
    // Same rule as the buy box: show the total only when the cadences differ on price. They
    // are all 35% off today, so one repeated figure would be noise.
    var totals = plans.map(function (pl) { return bundleAt(pl.months); });
    var varies = totals.some(function (t) { return Math.abs(t - totals[0]) > 0.005; });
    function priceBit(i) { return varies ? '<span class="p">' + money(totals[i]) + '</span>' : ''; }
    var curIdx = plans.findIndex(function (pl) { return pl.months === current.months; });

    $('vpq-freq-current').innerHTML = cadenceLabel(current.months) + priceBit(curIdx < 0 ? 0 : curIdx) +
      (current.months === rec ? REC_BADGE : '');
    $('vpq-freq-menu').innerHTML = plans.map(function (pl, i) {
      return '<li role="option" tabindex="-1" class="vpq-freq__opt" data-months="' + pl.months + '"' +
        ' aria-selected="' + (pl.months === current.months) + '">' +
        '<span>' + cadenceLabel(pl.months) + priceBit(i) + '</span>' +
        (pl.months === rec ? REC_BADGE : '') +
        '<svg class="tick" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
        '</li>';
    }).join('');

    // Name the items this cadence doesn't suit. A quiz bundle mixes supplies — 120 ct chews
    // run 60 days for a mid-size dog while the dental sticks run 30 — and shipping them all
    // on one plan is a real trade-off the customer should see before they buy, not after.
    var shipDays = current.months * 30;
    var off = BUNDLE.filter(function (b) {
      return b.selected && b.p.plans && b.p.plans.length && Math.abs(doseLine(b.p).days - shipDays) > 14;
    }).map(function (b) { return b.p.name; });
    $('vpq-freq-note').textContent = off.length
      ? off.join(' and ') + (off.length > 1 ? ' run' : ' runs') + ' out on a different cycle — you can change ' + (off.length > 1 ? 'those' : 'that') + ' anytime in your account.'
      : 'Matches how long each formula lasts for ' + (S.name || 'your dog') + ' — no gaps, nothing piling up.';
  }

  function renderBundle() {
    var addons = BUNDLE.slice(1);
    var addWrap = $('vpq-r-addons'), list = $('vpq-r-addlist');
    if (addons.length) {
      addWrap.hidden = false;
      list.innerHTML = addons.map(function (b, i) {
        var idx = i + 1;
        return '<button type="button" class="vpq-add' + (b.selected ? ' is-on' : '') + '" data-idx="' + idx + '" aria-pressed="' + b.selected + '">' +
          '<span class="vpq-add__check" aria-hidden="true"></span>' +
          '<img src="' + (b.p.img || '') + '" alt="">' +
          '<span class="vpq-add__info"><span class="n">' + (b.p.name || '') + '</span><span class="w">' + (b.why || '') + '</span></span>' +
          '<span class="vpq-add__p">' + money(itemPrice(b)) + '</span></button>';
      }).join('');
    } else { addWrap.hidden = true; }

    var total = 0, oneTotal = 0, count = 0;
    BUNDLE.forEach(function (b) { if (!b.selected) return; count++; total += itemPrice(b); oneTotal += b.p.one; });
    $('vpq-bundle-count').textContent = count + (count === 1 ? ' item' : ' items');
    $('vpq-bundle-total').textContent = money(total);

    var save = oneTotal - total, saveEl = $('vpq-bundle-save');
    if (save > 0.005) { saveEl.hidden = false; saveEl.textContent = 'You save ' + money(save) + (S.subOn ? ' with subscription' : ''); }
    else { saveEl.hidden = true; }

    var pct = oneTotal > 0 ? Math.round((save / oneTotal) * 100) : 0;
    $('vpq-sub-badge').textContent = (S.subOn && pct > 0) ? pct + '% off' : '';

    var st = $('vpq-sub-toggle');
    st.classList.toggle('is-on', S.subOn);
    st.setAttribute('aria-pressed', String(S.subOn));
    renderFreq();
  }

  function addBundle(btn) {
    var items = [];
    BUNDLE.forEach(function (b) {
      if (!b.selected || typeof b.p.id !== 'number') return;
      var it = { id: b.p.id, quantity: 1 };
      var pl = S.subOn ? planFor(b.p) : null;
      if (pl) it.selling_plan = pl.id;
      items.push(it);
    });
    if (!items.length) { var link = BUNDLE[0] && BUNDLE[0].p.link; if (link) window.location.href = link; return; }
    if (btn.dataset.loading) return; btn.dataset.loading = '1';
    var orig = btn.textContent; btn.textContent = 'Adding to cart…';
    var done = function () { btn.dataset.loading = ''; btn.textContent = orig; };
    var toCart = function () { fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }).then(function (r) { if (!r.ok) throw 0; window.location.href = '/cart'; }).catch(function () { done(); window.location.href = '/cart'; }); };
    if (window.VPCart && window.VPCart.addItems) {
      window.VPCart.addItems(items).then(done).catch(toCart);
    } else { toCart(); }
  }

  function restart() { location.reload(); }

  function init() {
    root = document.querySelector('.vp-quiz');
    if (!root) return;
    steps = root.querySelectorAll('.vpq-step');
    root.querySelectorAll('[data-q]').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = b.dataset.q;
        root.querySelectorAll('[data-q="' + q + '"]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        if (q === 'weight') { S.weight = +b.dataset.v; setTimeout(function () { goto(2); }, 220); }
        if (q === 'age') { S.age = b.dataset.v; setTimeout(function () { goto(3); }, 220); }
      });
    });
    root.querySelectorAll('[data-m]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.dataset.m, on = b.getAttribute('aria-pressed') === 'true';
        b.setAttribute('aria-pressed', String(!on));
        if (on) delete S.multi[k]; else S.multi[k] = true;
      });
    });
    var addBtn = $('vpq-r-link');
    if (addBtn) addBtn.addEventListener('click', function (e) { e.preventDefault(); addBundle(addBtn); });

    var addList = $('vpq-r-addlist');
    if (addList) addList.addEventListener('click', function (e) {
      var b = e.target.closest('[data-idx]');
      if (!b) return;
      var i = parseInt(b.getAttribute('data-idx'), 10);
      if (BUNDLE[i]) { BUNDLE[i].selected = !BUNDLE[i].selected; renderBundle(); }
    });

    var subToggle = $('vpq-sub-toggle');
    if (subToggle) subToggle.addEventListener('click', function () { S.subOn = !S.subOn; renderBundle(); });

    var freqTrigger = $('vpq-freq-trigger'), freqMenu = $('vpq-freq-menu'), freqWrap = $('vpq-freq');
    if (freqTrigger) {
      freqTrigger.addEventListener('click', function () { freqOpen(freqMenu.hidden); });
      freqTrigger.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); freqOpen(true); }
      });
    }
    if (freqMenu) {
      freqMenu.addEventListener('click', function (e) {
        var li = e.target.closest('[role="option"]');
        if (li) chooseMonths(li);
      });
      freqMenu.addEventListener('keydown', function (e) {
        var items = Array.prototype.slice.call(freqMenu.querySelectorAll('[role="option"]'));
        var i = items.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
        else if (e.key === 'Home') { e.preventDefault(); items[0].focus(); }
        else if (e.key === 'End') { e.preventDefault(); items[items.length - 1].focus(); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (items[i]) chooseMonths(items[i]); }
        else if (e.key === 'Escape' || e.key === 'Tab') { freqOpen(false); freqTrigger.focus(); }
      });
    }
    document.addEventListener('click', function (e) {
      if (!freqWrap || freqWrap.hidden || !freqMenu || freqMenu.hidden) return;
      if (!freqWrap.contains(e.target)) freqOpen(false);
    });
    window.VPQ = { S: S, goto: goto, afterIssues: afterIssues, finish: finish, restart: restart };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
